import { render, staticRenderFns } from "./SchoolDistrictEstimator.vue?vue&type=template&id=ca147e00&lang=pug"
import script from "./SchoolDistrictEstimator.vue?vue&type=script&lang=ts"
export * from "./SchoolDistrictEstimator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports